import { format } from 'date-fns';

import { Tag, Text } from '@nvision/ui';

import { Card } from '@/components/card';

import type { ProjectSummary } from '../../../models';

import styles from './project-card.module.css';

interface ProjectCardProps {
  project: ProjectSummary;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  return (
    <Card>
      <Card.Header>
        <div className={styles.header}>
          <Text size="sm" weight="semibold">
            {project.projectName}
          </Text>
          {project.isActive ? (
            <Tag success>
              <Text size="sm">Active</Text>
            </Tag>
          ) : (
            <Tag>
              <Text size="sm">Inactive</Text>
            </Tag>
          )}
        </div>
      </Card.Header>
      <Card.Main>
        <div className={styles.cardRow}>
          <Card.Field>
            <Text size="xs" elementType="div">
              Project Start Date
            </Text>
            <Text size="xs" elementType="div" weight="semibold">
              {project.startDate ? format(project.startDate, 'dd-MMM-yyyy') : '—'}
            </Text>
          </Card.Field>
          <Card.Field>
            <Text size="xs" elementType="div">
              Project End Date
            </Text>
            <Text size="xs" elementType="div" weight="semibold">
              {project.endDate ? format(project.endDate, 'dd-MMM-yyyy') : '—'}
            </Text>
          </Card.Field>
          <Card.Field>
            <Text size="xs" elementType="div">
              Project Description
            </Text>
            <Text size="xs" elementType="div" weight="semibold">
              {project.description}
            </Text>
          </Card.Field>
        </div>
      </Card.Main>
    </Card>
  );
};
